import React from 'react';
import { StarIcon } from 'lucide-react';
import MerchCategoryPage, { MerchProduct } from '../../components/Merch/MerchCategoryPage';
const artProducts: MerchProduct[] = [{
  id: 'p1',
  name: 'Fantasy Landscape Poster',
  vendorName: 'WhimsyReads',
  vendorSlug: 'whimsy-reads',
  vendorImage: 'https://images.unsplash.com/photo-1586892477838-2b96e85e0f96?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80',
  image: 'https://images.unsplash.com/photo-1579783902614-a3fb39279c0f?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
  price: 25.0,
  rating: 4.8,
  reviewCount: 67,
  subcategory: 'Posters',
  tags: ['fantasy', 'landscape', 'matte'],
  description: 'High-quality matte poster depicting a sprawling fantasy kingdom.',
  shipping: 'Worldwide',
  location: 'Portland, OR'
}, {
  id: 'p2',
  name: 'Character Portrait Print',
  vendorName: 'BangkokBookDesigns',
  vendorSlug: 'bangkok-book-designs',
  vendorImage: 'https://images.unsplash.com/photo-1528698827591-e19ccd7bc23d?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80',
  image: 'https://images.unsplash.com/photo-1549887552-93f27ea6b705?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
  price: 18.0,
  rating: 4.9,
  reviewCount: 120,
  subcategory: 'Fine Art Prints',
  tags: ['character art', 'portrait', 'digital'],
  description: 'Detailed character portrait on archival quality paper.',
  shipping: 'Worldwide',
  location: 'Bangkok, Thailand'
}, {
  id: 'p3',
  name: 'Vintage Bookplate Set',
  vendorName: 'QuillAndInkArt',
  vendorSlug: 'quill-and-ink-art',
  vendorImage: 'https://images.unsplash.com/photo-1603827457577-609e6f42a45e?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80',
  image: 'https://images.unsplash.com/photo-1603827457577-609e6f42a45e?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
  price: 12.0,
  rating: 5.0,
  reviewCount: 85,
  subcategory: 'Digital Downloads',
  tags: ['printable', 'vintage', 'custom'],
  description: 'Digital download of 5 vintage-style bookplate designs.',
  shipping: 'Digital Download',
  location: 'Boston, MA'
}, {
  id: 'p4',
  name: 'Literary Quote Canvas',
  vendorName: 'LondonBookLovers',
  vendorSlug: 'london-book-lovers',
  vendorImage: 'https://images.unsplash.com/photo-1571331627305-b3c24197a15b?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80',
  image: 'https://images.unsplash.com/photo-1580136608260-4eb11f4b64fe?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
  price: 45.0,
  rating: 4.7,
  reviewCount: 42,
  subcategory: 'Canvas',
  tags: ['typography', 'decor', 'quote'],
  description: 'Stretched canvas print featuring a famous Jane Austen quote.',
  shipping: 'Worldwide',
  location: 'London, UK'
}, {
  id: 'p5',
  name: 'Map of Middle Earth Style',
  vendorName: 'FantasyRealmCrate',
  vendorSlug: 'fantasy-realm-crate',
  vendorImage: 'https://images.unsplash.com/photo-1578950435899-d1c1bf932b1d?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80',
  image: 'https://images.unsplash.com/photo-1524661135-423995f22d0b?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
  price: 30.0,
  rating: 4.8,
  reviewCount: 210,
  subcategory: 'Posters',
  tags: ['map', 'cartography', 'vintage'],
  description: 'Detailed fantasy map printed on parchment-style paper.',
  shipping: 'Worldwide',
  location: 'Denver, CO'
}, {
  id: 'p6',
  name: 'Gothic Horror Art Print',
  vendorName: 'DarkAndDisturbed',
  vendorSlug: 'dark-and-disturbed',
  vendorImage: 'https://images.unsplash.com/photo-1614064641938-3bbee52942c7?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80',
  image: 'https://images.unsplash.com/photo-1500462918059-b1a0cb512f1d?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
  price: 22.0,
  rating: 4.9,
  reviewCount: 95,
  subcategory: 'Fine Art Prints',
  tags: ['horror', 'gothic', 'dark'],
  description: 'Hauntingly beautiful art print for fans of gothic literature.',
  shipping: 'US & Canada',
  location: 'Salem, MA'
}, {
  id: 'p7',
  name: 'Botanical Book Illustration',
  vendorName: 'KiwiBookCrafts',
  vendorSlug: 'kiwi-book-crafts',
  vendorImage: 'https://images.unsplash.com/photo-1516876437184-593fda40c542?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80',
  image: 'https://images.unsplash.com/photo-1470509037663-253afd7f0f51?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
  price: 20.0,
  rating: 4.6,
  reviewCount: 38,
  subcategory: 'Fine Art Prints',
  tags: ['nature', 'botanical', 'illustration'],
  description: 'Watercolor illustration of plants mentioned in classic literature.',
  shipping: 'Worldwide',
  location: 'Wellington, NZ'
}, {
  id: 'p8',
  name: 'Custom Author Portrait',
  vendorName: 'TorontoBookishGoods',
  vendorSlug: 'toronto-bookish-goods',
  vendorImage: 'https://images.unsplash.com/photo-1544816155-12df9643f363?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80',
  image: 'https://images.unsplash.com/photo-1513364776144-60967b0f800f?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
  price: 85.0,
  rating: 5.0,
  reviewCount: 15,
  subcategory: 'Commissions',
  tags: ['custom', 'portrait', 'gift'],
  description: 'Commission a custom digital portrait of your favorite author or character.',
  shipping: 'Digital Download',
  location: 'Toronto, Canada'
}];
const ArtPrints = () => {
  return <MerchCategoryPage title="Bookish Art Prints" description="Transform your walls with literary art. From fantasy maps to character portraits and typography, find the perfect piece for your reading nook." icon={<StarIcon className="h-5 w-5" data-id="element-10474" data-mp="gbnldfmn6xm3" />} products={artProducts} filterOptions={{
    subcategories: ['Posters', 'Fine Art Prints', 'Canvas', 'Digital Downloads', 'Commissions'],
    priceRanges: [{
      label: 'Under $20',
      min: 0,
      max: 20
    }, {
      label: '$20 - $50',
      min: 20,
      max: 50
    }, {
      label: '$50+',
      min: 50,
      max: null
    }],
    vendors: Array.from(new Set(artProducts.map(p => p.vendorName))).sort()
  }} data-id="element-10473" data-mp="6c6if5yryxtt" />;
};
export default ArtPrints;